module.exports = __webpack_public_path__ + "img/PEC3000_1-1.51fff8bc.jpg";